// extracted by mini-css-extract-plugin
export default {"imagePickerWrapper":"image-picker_imagePickerWrapper__woAXj","imageCounter":"image-picker_imageCounter__oeDPK","images":"image-picker_images__IsVCW"};